import { getNoteName } from '../../../util/getNoteName';

const getNotesArray = (lowNote, highNote) => {
   const notes = [];
   for (let note = highNote; note >= lowNote; note -= 1) {
      notes.push(getNoteName(note));
   }
   return notes;
};

export { getNotesArray };
